import * as Yup from 'yup';

import {
  MAX_PASSWORD_LENGTH,
  MIN_PASSWORD_LENGTH,
  PasswordRuleViolation,
  findPasswordRuleViolation,
} from '@e-socna/users';

// A new password, checked once typed (an empty one is left to the form).
export const newPasswordSchema = Yup.string()
  .test(
    'min-length',
    `Le mot de passe doit contenir au moins ${MIN_PASSWORD_LENGTH.toString()} caractères`,
    (newPassword) =>
      !newPassword ||
      findPasswordRuleViolation(newPassword) !== PasswordRuleViolation.TooShort,
  )
  .test(
    'max-length',
    `Le mot de passe ne doit pas dépasser ${MAX_PASSWORD_LENGTH.toString()} caractères`,
    (newPassword) =>
      findPasswordRuleViolation(newPassword) !== PasswordRuleViolation.TooLong,
  )
  .test(
    'differs-from-current',
    'Le nouveau mot de passe doit être différent du mot de passe actuel',
    (newPassword, { parent }) =>
      !newPassword ||
      newPassword !==
        (parent as Readonly<{ currentPassword?: string }>).currentPassword,
  );

export const newPasswordConfirmationSchema = Yup.string().when('newPassword', {
  is: (newPassword: string | undefined) => !!newPassword,
  then: (schema) =>
    schema
      .required('Confirmez le nouveau mot de passe')
      .oneOf(
        [Yup.ref('newPassword')],
        'Les mots de passe ne correspondent pas',
      ),
});

export const currentPasswordSchema = Yup.string().required(
  'Le mot de passe actuel confirme la modification',
);
